import React, { useEffect, useRef, useState } from 'react'
import { Translation, Locale } from 'locale'
import { ToggleButton } from 'view/components/buttons'
import { deltaIcon } from 'view/components/datagrid/styles/gridIconSet'
import { ColumnItem, ColumnList } from 'view/components/datagrid/toolbar/columnSelectorStyles'
import { CheckboxField } from 'view/components/inputs'
import {
  ColumnCopySelectorOverlay,
  ColumnCopySelectorWrapper,
  ColumnCopySelectorTitle,
  DeltaIconContainer,
  ColumnCopySelectorStrip,
  CopyButton
} from './ColumnCopySelectorStyles'
import * as gridIcons from 'view/components/datagrid/styles/gridIconSet'
import { GridToolbarSettings } from 'store/grid/gridTypes'

const onContainerClick = (event: React.MouseEvent) => {
  event.preventDefault()
  event.stopPropagation()
}

export interface ColumnCopySelectorSelection {
  isSelected: boolean
  selectionId: string
  label: string
  indent: boolean
  headerName: string
  delta: boolean
}

interface ColumnCopySelectorComponentProps {
  selections: ColumnCopySelectorSelection[]
  toggleSelectionSelected: (id: string) => void
  handleCopy: (...args: any[]) => void
  onToggleShowCopySelected: () => void
  toolbarSettings: GridToolbarSettings
}

export const ColumnCopySelectorComponent: React.FC<ColumnCopySelectorComponentProps> = ({
  selections,
  toggleSelectionSelected,
  handleCopy,
  onToggleShowCopySelected,
  toolbarSettings
}) => {
  const [positionX, setPositionX] = useState(0)
  const [positionY, setPositionY] = useState(0)
  const copyButtonRef = useRef<HTMLElement>(null)

  useEffect(() => {
    const copyButton = copyButtonRef.current
    setPositionY(copyButton ? copyButton.getBoundingClientRect().bottom - 10 : 0)
    setPositionX(copyButton ? copyButton.getBoundingClientRect().left - 10 : 0)
  }, [])

  return (
    <>
      <ColumnCopySelectorStrip>
        <CopyButton tooltip={Translation.SC_SELECT_COLUMNS_TO_COPY} onClick={handleCopy}>
          {gridIcons.copyIcon}
        </CopyButton>
        <ToggleButton
          dataTestId={'QuickCopy-ToggleButton-CopySelectedColumns'}
          ref={copyButtonRef}
          tooltip={Translation.SC_COPY_SELECTED_COLUMNS}
          onToggle={onToggleShowCopySelected}
          on={toolbarSettings.showCopySelected}>
          {gridIcons.downArrowIcon}
        </ToggleButton>
      </ColumnCopySelectorStrip>
      {toolbarSettings.showCopySelected ? (
        <ColumnCopySelectorOverlay onClick={onToggleShowCopySelected}>
          <ColumnCopySelectorWrapper positionY={positionY} positionX={positionX} onClick={onContainerClick}>
            <ColumnCopySelectorTitle>{Locale.translate(Translation.TC_COLUMNS)}</ColumnCopySelectorTitle>
            <ColumnList>
              {selections.map(selection => (
                <ColumnItem
                  key={selection.selectionId}
                  indent={selection.indent}
                  onClick={() => toggleSelectionSelected(selection.selectionId)}>
                  <CheckboxField
                    label={
                      <DeltaIconContainer>
                        {selection.delta ? deltaIcon : ''} {selection.headerName || ''}
                      </DeltaIconContainer>
                    }
                    isChecked={selection.isSelected === true}
                    onUpdate={() => toggleSelectionSelected(selection.selectionId)}
                  />
                </ColumnItem>
              ))}
            </ColumnList>
          </ColumnCopySelectorWrapper>
        </ColumnCopySelectorOverlay>
      ) : null}
    </>
  )
}
